module.exports = __webpack_public_path__ + "static/media/signup.cc0d1069.svg";